module.exports = __webpack_public_path__ + "static/media/icons-menu_58.d7bc2551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons-menu_58.png
// module id = 460
// module chunks = 0